import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 18v-5l4 -2l4 2v5l-4 2l-4 -2","key":"svg-0"}],["path",{"d":"M8 11v-5l4 -2l4 2v5","key":"svg-1"}],["path",{"d":"M12 13l4 -2l4 2v5l-4 2l-4 -2","key":"svg-2"}]]

const IconHexagons = createReactComponent('outline', 'hexagons', 'Hexagons', __iconNode);

export default IconHexagons;